import { useEffect, useRef } from 'react';
import Swal from 'sweetalert2';

const RULES = [
  {
    match: (r) => ['in_progress', 'waiting'].includes(r.frStatus) && r.frIsCompliant,
    modal: {
      title: 'Demande conforme',
      text: 'La demande est désormais conforme. Souhaitez-vous passer son statut à « A accomplir » ?',

    },
    nextStatus: 'todo',
  },
  {
    match: (r) =>
      ['todo'].includes(r.frStatus) && !r.frIsCompliant,
    modal: {
      title: 'Documents(s) refusé(s)',
      html: "Au moins un document a été refusé. Souhaitez-vous passer son statut à « En cours de traitement » ?",

    },
    nextStatus: 'in_progress',
  },
];

export default function useFormalityAutoStatusTransition(
  request,
  onConfirm
) {
  const lastRuleRef = useRef(null);
  useEffect(() => {
    if (!request) return;
    if (!request.frAnalysis || Object.keys(request.frAnalysis).length === 0) {
      return;
    }
    const rule = RULES.find((r) => r.match(request));
    if (!rule || lastRuleRef.current === rule) return;

    lastRuleRef.current = rule;

    Swal.fire({
      ...rule.modal,
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm(rule.nextStatus);
      }
    });
  }, [request, onConfirm]);
}
